export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'

export const CREATE = 'CREATE';
export const FETCH_ALL = 'FETCH_ALL';
export const DELETE = 'DELETE';
export const FETCH_POST = 'FETCH_POST';
export const LIKE = 'LIKE';

export const CREATE_MSG = 'CREATE_MSG'
export const FETCH_MSG = 'FETCH_CONVERSATION'